<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <div class="header-button">
      <search-form
        ref="searchForm"
        :fields="search"
      />
      <div class="selections">
        <button-link
          type="success"
          to="/invite_new_users_configs/create"
        >
          <slot>添加邀请活动</slot>
        </button-link>
      </div>
    </div>

    <el-table
      :data="invite_new_users_configs"
      resource="invite_new_users_configs"
    >
      <!-- <el-table-column
        prop="id"
        label="ID"
        width="60"
        align="center"
      />-->
      <el-table-column
        prop="name"
        label="名称"
        min-width="150"
        align="center"
      />
      <el-table-column
        label="海报"
        align="center"
        prop="background_image"
        min-width="120"
      >
        <template slot-scope="scope">
          <img
            :src="scope.row.background_image"
            min-width="150"
            height="200"
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="area_name"
        label="区域"
        show-overflow-tooltip
        min-width="120"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag type="success">{{ scope.row.area_name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="condition_name"
        label="条件"
        min-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag type="danger">{{ scope.row.condition_name }}</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="coupon_name"
        label="赠送优惠券"
        show-overflow-tooltip
        min-width="9%"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-show="scope.row.is_give_coupon == 1">{{ scope.row.coupon_name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="coupon_num"
        label="赠送优惠券数量"
        show-overflow-tooltip
        min-width="4%"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag>{{ scope.row.coupon_num }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="balance"
        label="赠送余额"
        show-overflow-tooltip
        min-width="5%"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag type="danger">{{ scope.row.balance }}</el-tag>
        </template>
      </el-table-column> -->

      <el-table-column
        prop="start_time"
        label="活动开始时间"
        min-width="160"
        align="center"
      />
      <el-table-column
        prop="end_time"
        label="活动结束时间"
        min-width="160"
        align="center"
      />
      <el-table-column
        label="是否可重复"
        min-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_repeat == 1"
            type="success"
          >可重复</el-tag>
          <el-tag
            v-else-if="scope.row.is_repeat == 0"
            type="danger"
          >不可重复</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        min-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status == 1"
            type="success"
          >启用</el-tag>
          <el-tag
            v-else-if="scope.row.status == 0"
            type="danger"
          >禁用</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        width="250"
        align="center"
      >
        <template #default="{ row, $index }">
          <el-button-group>
            <row-to-edit />
            <row-destroy />
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getInviteNewUsersConfigs } from "@/api/invite-new-users-configs";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import ButtonLink from "@c/ButtonLink";
import { getAreas } from "@/api/area";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getUserByMobile } from "@/api/users";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../../env";
export default {
  name: "Index",
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
    ButtonLink
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      dialogVisible: false,
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          field: "name",
          label: "名称"
        },
        {
          type: "el-select",
          field: "is_repeat",
          label: "是否可重复",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 1,
              name: "可重复"
            },
            {
              id: 0,
              name: "不可重复"
            }
          ]
        },
        {
          type: "el-select",
          field: "status",
          label: "是否禁用",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 1,
              name: "启用"
            },
            {
              id: 0,
              name: "禁用"
            }
          ]
        }
      ],
      invite_new_users_configs: [],
      page: null,
      first_blood: true
    };
  },
  mixins: [mixinsAutoPageSize],
  async created() {
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[4].options.push.apply(
          this.search[4].options,
          merchant.data
        );
      }
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(200, newVal);
        const {
          data: { data, meta }
        } = await getInviteNewUsersConfigs(newVal.query);
        this.invite_new_users_configs = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
</style>
